import React from 'react';
import ImageHTML from '../imgenHTML/ImageHTML';
import { PATHURLDOMAIN } from '../../constantes/constantes';
import { dateFormatDDmesAnio } from '../../functions/functions';

/**
 * Componente que renderiza una lista de resultados de búsqueda.
 * Cada resultado incluye imagen, título y categoría.
*/
export default function CardResults({ data }) {
  /**
   * Envía un mensaje al padre con un tipo específico de evento.
   * Utilizado para el seguimiento de interacciones (tageo).
  */
  const sendMessageToParent = (data) => {
    window.parent.postMessage({ type: 'tageo', data }, PATHURLDOMAIN);
  };

  // Manejador del clic sobre el resultado.
  const handleButtonClick = (e, item) => {
    // e.preventDefault();
    sendMessageToParent({ event: 'click', data: item });
  };
  
  return (
    <section id="resultados" className='grid-news'>
      {data.map((item, id) => {
        const { title, url, publish_date, image, category, subcategory, tags = [] } = item;
        const iconClass = `icon-default ${subcategory ? 'icon-' + subcategory : ''} ${category ? 'icon-' + category : ''}`;
        const categoryText = (subcategory || category || '').replace(/-/g, ' ');

        return (
          <div key={`${title} - ${id}`} className="amx-notas-homes">
            <a className="item" href={url} title={title} target="_parent" rel='bookmark' onClick={(e) => handleButtonClick(e, item)}>
              <div className="thumb">
                {tags && tags.includes("video") && <span className="amx-icon-play" />}
                <ImageHTML url={image} title={title} />
              </div>

              <div className="info">
                <h4 className={iconClass}>{categoryText}</h4>
                <h3>{title}</h3>
                <time dateTime={publish_date} className="datetime">{dateFormatDDmesAnio(publish_date)}</time>
              </div>
            </a>
          </div>
        );
      })}
    </section>
  );
}